import { render, staticRenderFns } from "./AttachmentsStorage.vue?vue&type=template&id=49e74112&scoped=true&"
import script from "./AttachmentsStorage.vue?vue&type=script&lang=js&"
export * from "./AttachmentsStorage.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentsStorage.vue?vue&type=style&index=0&id=49e74112&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e74112",
  null
  
)

export default component.exports